import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'specialClaims.deleteModal.title',
    defaultMessage: 'Delete Special Claim Record',
  },
  confirmationText: {
    id: 'specialClaims.deleteModal.confirmationText',
    defaultMessage: 'Are you sure you want to delete this record?',
  },
  warningBanner: {
    id: 'specialClaims.deleteModal.warningBanner',
    defaultMessage:
      'Deleting this record will remove it from the current voucher. ' +
      'If the voucher has already been submitted, it will be returned to Draft ' +
      'and a new submission will be required.',
  },
  cancel: {
    id: 'specialClaims.deleteModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'specialClaims.deleteModal.confirm',
    defaultMessage: 'Confirm',
  },
});
